import { defineMessages } from 'react-intl';

export default defineMessages({
  'Reverse.Repairer.Errors.RepairerInterventionReport.ServiceNotAllowed': {
    defaultMessage: 'Service not allowed',
    id: 'Reverse.Repairer.Errors.RepairerInterventionReport.ServiceNotAllowed',
  },
  'Reverse.Repairer.Errors.RepairerInterventionReport.SparePartNotAllowed': {
    defaultMessage: 'Spare part not allowed',
    id: 'Reverse.Repairer.Errors.RepairerInterventionReport.SparePartNotAllowed',
  },
  'Reverse.Repairer.Errors.RepairerInterventionReport.DuplicatedStockItem': {
    defaultMessage: "Can't use the same sotck item",
    id: 'Reverse.Repairer.Errors.RepairerInterventionReport.DuplicatedStockItem',
  },
  'Reverse.Repairer.Errors.RepairerInterventionReport.MissingManageInterventionReportSparePartLinesPermission':
    {
      defaultMessage:
        'Missing manage intervention report spare part lines permission',
      id: 'Reverse.Repairer.Errors.RepairerInterventionReport.MissingManageInterventionReportSparePartLinesPermission',
    },
});
